<template>
  <div class="spinner">
    <div :class="['bounce', 'first']" />
    <div :class="['bounce', 'second']" />
    <div class="bounce" />
  </div>
</template>

<script>
export default {
  name: 'LoadingIndicator',
};
</script>

<style lang="scss" scoped>
.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $bb-neutral-0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;

  .bounce {
    width: 18px;
    height: 18px;
    background-color: $bb-primary-1;
    border-radius: 100%;

    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;

    &.first {
      margin-right: $bb-spacing-1;

      -webkit-animation-delay: -0.32s;
      animation-delay: -0.32s;
    }

    &.second {
      margin-right: $bb-spacing-1;

      -webkit-animation-delay: -0.16s;
      animation-delay: -0.16s;
    }
  }

  @-webkit-keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
    }
  }

  @keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
}
</style>
